/**
 * 该插件可根据菜单配置自动生成 ANTD menu组件
 * menuOptions示例：
 * [
 *  {
 *    name: '菜单名称',
 *    path: '菜单路由',
 *    meta: {
 *      icon: '菜单图标',
 *      invisible: 'boolean, 是否不可见, 默认 false',
 *    },
 *    children: [子菜单配置]
 *  },
 *  {
 *    name: '菜单名称',
 *    path: '菜单路由',
 *    meta: {
 *      icon: '菜单图标',
 *      invisible: 'boolean, 是否不可见, 默认 false',
 *    },
 *    children: [子菜单配置]
 *  }
 * ]
 *
 * i18n: 国际化配置。系统默认会根据 options route配置的 path 和 name 生成英文以及中文的国际化配置，如需自定义或增加其他语言，配置
 * 此项即可。如：
 * i18n: {
 *   messages: {
 *     CN: {dashboard: {name: '监控中心'}}
 *     HK: {dashboard: {name: '監控中心'}}
 *   }
 * }
 * */
 import Menu from 'ant-design-vue/es/menu'
//  import Icon from 'ant-design-vue/es/icon'
 import fastEqual from 'fast-deep-equal'
//  import order from '@/assets/img/icon/order.png'
//  import wherehouse from '@/assets/img/icon/wherehouse.png'
//  import seting from '@/assets/img/icon/seting.png'
//  import orderActive from '@/assets/img/icon/order_active.png'
//  import wherehouseActive from '@/assets/img/icon/wherehouse_active.png'
//  import setingActive from '@/assets/img/icon/seting_active.png'
 import Icon from '@/components/icon'
 import Badge from '@/components/badge'
 // import {getI18nKey} from '@/utils/routerUtil'

  const {Item, SubMenu} = Menu
  const iconData = {
    '/order': 'icon-order_28x28_normal',
    '/setting': 'icon-setting_28x28_normal',
    '/seekWarehouse': 'icon-cang_28x28_normal',
    '/data': 'icon-Data_24x24_normal',
    '/application': 'icon-apply_24x24_normal',
  }
  const active = {
    '/order': 'icon-order_28x28_active',
    '/setting': 'icon-setting_28x28_active',
    '/seekWarehouse': 'icon-cang_28x28_active',
    '/data': 'icon-Data_24x24_active',
    '/application': 'icon-apply_24x24_active',
  }


 export default {
   name: 'IMenu',
   props: {
     options: {
       type: Array,
       required: true
     },
     theme: {
       type: String,
       required: false,
       default: 'dark'
     },
     mode: {
       type: String,
       required: false,
       default: 'inline'
     },
     collapsed: {
       type: Boolean,
       required: false,
       default: false
     },
     count: {
      type: Number,
      required: false,
     },
     i18n: Object,
     openKeys: Array
   },
   data () {
     return {
       selectedKeys: [],
       sOpenKeys: [],
       cachedOpenKeys: []
     }
   },
   computed: {
     menuTheme() {
       return this.theme === 'light' ? this.theme : 'dark'
     }
   },
   created () {
     this.updateMenu()
     if (this.options.length > 0 && !this.options[0].fullPath) {
       this.formatOptions(this.options, '')
     }
     // 自定义国际化配置
     if(this.i18n && this.i18n.messages) {
       const {messages} = this.i18n
       Object.keys(messages).forEach(key => {
         this.$i18n.mergeLocaleMessage(key, messages[key])
       })
     }
   },
   watch: {
     options(val) {
       if (val.length > 0 && !val[0].fullPath) {
         this.formatOptions(this.options, '')
       }
     },
     i18n(val) {
       if(val && val.messages) {
         const {messages} = this.i18n
         Object.keys(messages).forEach(key => {
           this.$i18n.mergeLocaleMessage(key, messages[key])
         })
       }
     },
     collapsed (val) {
       if (val) {
         this.cachedOpenKeys = this.sOpenKeys
         this.sOpenKeys = []
       } else {
         this.sOpenKeys = this.cachedOpenKeys
       }
     },
     $route() {
       this.updateMenu()
     },
     sOpenKeys(val) {
       this.$emit('openChange', val)
       this.$emit('update:openKeys', val)
     }
   },
   methods: {
     renderIcon (h, icon, key, path) {
        if (this.$scopedSlots.icon && icon && icon !== 'none') {
          const vnodes = this.$scopedSlots.icon({icon, key})
          vnodes.forEach(node => {
            const vnode = node
            vnode.data.class = vnode.data.class ? vnode.data.class : []
            vnode.data.class.push('anticon')
          })
          return vnodes
        }
        //  return !icon || icon === 'none' ? null : h('i', {class:  `iconfont ${icon}`})
        if(!icon || icon === 'none'){
          return null
        }

        return this.filterIcon(key) ? h(Icon, {attrs:  {name: active[path] , class: 'menu-icon'}}) : h(Icon, {attrs:  {name: icon, class: 'menu-icon'}})
     },
     filterIcon(key){
       return (this.selectedKeys.length > 0 && this.selectedKeys.includes(key))
     },
     renderMenuItem (h, menu) {
       const tag = 'router-link'
       let config = {props: {to: menu.fullPath}, attrs: { class: 'menu-router' }}
       if (menu.meta && menu.meta.link) {
         config = {attrs: { class: 'menu-router' , href: menu.meta.link, target: '_blank'}}
       }
       const hasBadge = menu.fullPath === '/application'
       return h(
         Item, {key: menu.fullPath},
         [
           h(tag, config,
            [
              this.renderIcon(h, iconData[menu.fullPath], menu.fullPath, menu.fullPath),
              menu.name,
            ],
           ),
           h(hasBadge ? Badge : '', {attrs: {count: this.count}, class: 'menu-badge'})
         ]
       )
     },
     renderSubMenu (h, menu, topSign) {
       const that = this
       const subItem = [h('span', {slot: 'title', attrs: { class: `menu-router ${topSign === '0'?'top-menu':'no-top-menu'}`, }},
         [
           this.renderIcon(h, iconData[menu.fullPath], menu.fullPath, menu.fullPath),
           menu.name
         ]
       )]
       const itemArr = []
       menu.children.forEach((item) => {
         itemArr.push(that.renderItem(h, item))
       })
       return h(SubMenu, {key: menu.fullPath},
         subItem.concat(itemArr)
       )
     },
     renderItem (h, menu, topSign=1) {
       const {meta} = menu
       if (!meta || !meta.invisible) {
         let renderChildren = false
         const {children} = menu
         if (children !== undefined) {
           for (let i = 0; i < children.length; i += 1) {
             const childMeta = children[i].meta
             if (!childMeta || !childMeta.invisible) {
               renderChildren = true
               break
             }
           }
         }
         return (menu.children && renderChildren) ? this.renderSubMenu(h, menu, topSign) : this.renderMenuItem(h, menu)
       }
       return null
     },
     renderMenu (h, menuTree) {
       const that = this
       const menuArr = []
       menuTree.forEach((menu, i) => {
         menuArr.push(that.renderItem(h, menu, '0', i))
       })
       return menuArr
     },
     formatOptions(options, parentPath) {
       options.forEach(routes => {
         const route = routes
         const isFullPath = route.path.substring(0, 1) === '/'
         route.fullPath = isFullPath ? route.path : `${parentPath  }/${  route.path}`
         if (route.children) {
           this.formatOptions(route.children, route.fullPath)
         }
       })
     },
     updateMenu () {
       const matchedRoutes = this.$route.matched.filter(item => item.path !== '')
       this.selectedKeys = this.getSelectedKey(this.$route)
       let openKeys = matchedRoutes.map(item => item.path)
       openKeys = openKeys.slice(0, openKeys.length -1)
       if (this.$route.path === "/order/createOrder") {
        this.sOpenKeys = []
       } else if (!fastEqual(openKeys, this.sOpenKeys)) {
        if (this.collapsed || this.mode === 'horizontal') {
          this.cachedOpenKeys = openKeys
        } else {
          this.sOpenKeys = openKeys
        }
        // this.collapsed || this.mode === 'horizontal' ? this.cachedOpenKeys = openKeys : this.sOpenKeys = openKeys
      }
     },
     getSelectedKey (route) {
       return route.matched.map(item => item.path)
     }
   },
   render (h) {
     return h(
       Menu,
       {
         props: {
           theme: this.menuTheme,
           mode: this.$props.mode,
           selectedKeys: this.selectedKeys,
           openKeys: this.openKeys ? this.openKeys : this.sOpenKeys,
         },
         on: {
           'update:openKeys': (val) => {
             this.sOpenKeys = val
           },
           click: (e) => {
             const obj = e
             obj.selectedKeys = [obj.key]
             this.$emit('select', obj)
           }
         }
       }, this.renderMenu(h, this.options)
     )
   }
 }

